<template>
  <div>
    <Financial></Financial>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import Financial from '../components/Financial.vue'
export default {
  components: { Financial },
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const obj = reactive({
      // height: store.state.windowHeight - 150
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '5') 
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 渲染画面
    const renderView = () => {
      requestData()
    }

    // 后台获取数据
    const requestData = () => {
      processData()
    }
    
    // 加工处理数据
    const processData = (res) => {
    }

    return {
      obj,
      store
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
